import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import {
	//BootstrapVue,
	LayoutPlugin,
	ModalPlugin,
	CardPlugin,
	ButtonGroupPlugin,
	ButtonPlugin,
	FormPlugin,
	FormDatepickerPlugin,
	FormTimepickerPlugin,
	FormInputPlugin,
	FormSelectPlugin,
	FormCheckboxPlugin,
	FormTextareaPlugin,
	FormSpinbuttonPlugin,
	FormGroupPlugin,
	LinkPlugin,
	NavPlugin,
	NavbarPlugin,
	SpinnerPlugin,
	TabsPlugin,
	ImagePlugin,
	BIcon,
	BIconPower,
	BIconChevronDoubleLeft,
	BIconChevronDoubleRight,
	BIconXSquare,
	BIconCheckSquare,
	BIconExclamationCircle,
	BIconPlusSquareFill,
	BIconPlusSquare,
	BIconX,
	BIconPersonCheck,
	BIconPersonDash,
} from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import VueCookies from "vue-cookies"

Vue.config.productionTip = false

//Vue.use(BootstrapVue)
Vue.component("BIcon", BIcon)
Vue.component("BIconPower", BIconPower)
Vue.component("BIconChevronDoubleLeft", BIconChevronDoubleLeft)
Vue.component("BIconChevronDoubleRight", BIconChevronDoubleRight)
Vue.component("BIconXSquare", BIconXSquare)
Vue.component("BIconCheckSquare", BIconCheckSquare)
Vue.component("BIconExclamationCircle", BIconExclamationCircle)
Vue.component("BIconPlusSquareFill", BIconPlusSquareFill)
Vue.component("BIconPlusSquare", BIconPlusSquare)
Vue.component("BIconX", BIconX)
Vue.component("BIconPersonCheck", BIconPersonCheck)
Vue.component("BIconPersonDash", BIconPersonDash)

Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(FormTimepickerPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormSpinbuttonPlugin)
Vue.use(FormGroupPlugin)
Vue.use(LinkPlugin)
Vue.use(NavPlugin)
Vue.use(NavbarPlugin)
Vue.use(SpinnerPlugin)
Vue.use(TabsPlugin)
Vue.use(ImagePlugin)

Vue.use(VueCookies)

Vue.$cookies.config("4d", "/", "", "", false) // expires, path, domain, secure, samesite

Vue.prototype.$months = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
]
Vue.prototype.$apiURL = "https://medex.lifeforcept.com:3000"
Vue.prototype.$max = 6 // Maximum # of attendees allowed for MedEx classes @ LifeForce

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount("#app")
